import { connect } from "react-redux";

import Component from "./Component";
import {
    getWidth,
    isDesktop,
    isMobile,
    isTablet,
} from "domain/Version/selectors";
import {
    getPlaygroundById,
    getPlaygroundOptionsOnWords,
} from "domain/Playgrounds/selectors";
import {
    getCityById,
    getPlaygroundTypeById,
} from "domain/Directories/selectors";

const mapStateToProps = (state, { playgroundId }) => {
    const playground = getPlaygroundById(state, playgroundId);
    const city = getCityById(state, playground.city_id);

    return {
        playground,
        minWidth: getWidth(state),
        cityName: city.name,
        type: getPlaygroundTypeById(state, playground.type_id),
        options: getPlaygroundOptionsOnWords(state, playgroundId),
        isMobile: isMobile(state),
        isDesktop: isDesktop(state),
        isTablet: isTablet(state),
    };
};
export default connect(mapStateToProps)(Component);
